import { log } from '../logger/logger.js';
let currentFramework;
const setCurrentFramework = (framework) => {
    log("cmp", `Framework set to ${framework}`);
    currentFramework = framework;
};
const getCurrentFramework = () => currentFramework;
export { getCurrentFramework, setCurrentFramework };
